import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const AuthRoute = ({ children }) => {

  const { user } = useAuth();

  if (user && user.emailVerified && user.claims && user.claims.businessProfile) {
    return <Navigate to="/admin/dashboard" />;
  } else if (user && user.claims && !user.claims.businessProfile) {
    return <Navigate to="/setup-profile" />;
  }

  return children;
};

export default AuthRoute;